import * as React from 'react'
import TextField from '@mui/material/TextField'

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { useSelector } from 'react-redux'
import WebService from '@util/webService'
import useAlert from '@hooks/useAlert'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import MyDialog from '@components/MyDialog'
import Button from '@mui/material/Button'
import MUITable from '@mui/material/Table'
import MyTableHead from '@components/MyTableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import { Fragment, useRef, useState } from 'react'
import FlatButton from '@components/FlatButton'
import TableBody from '@mui/material/TableBody'
import { Container, TablePagination, Typography } from '@mui/material'
import { tablePaginationClasses } from '@mui/material/TablePagination'
import TableFooter from '@mui/material/TableFooter'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import LastPageIcon from '@mui/icons-material/LastPage'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import { findCode, truncate } from '@util/helper'
import ManagerMessagePartSend from '@pages/manager/manager-message.part.send'
import ManagerMessagePartPost from './manager-message.part.post'
import { generatePath, useParams } from 'react-router-dom'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import { FormControl, InputLabel, Input, FormHelperText, Alert, Select, MenuItem, Grid } from '@mui/material'
import MyDialog2 from '@components/MyDialog2'
import MyDialog3 from '@components/MyDialog3'
import ManagerMessagePartView from './manager-message.part.view'
import { useLocation } from 'react-router-dom'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import ManagerMessagePartUser from './manager-message.part.user'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'

const attdncCodes = ['TP02', 'TP03', 'TP10']
export default function ManagerMessagePage() {
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [dataList, set_dataList] = useState([])
  const [totalCount, set_totalCount] = useState(0)
  const dgHandler = useState(false)
  const dgHandler2 = useState(false)
  const dgHandler3 = useState(false)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 })
  const { more } = useParams()
  const [tabValue, set_tabValue] = useState('-1')
  const location = useLocation()
  const [smstList, set_smstList] = useState([])
  const [lectures, set_lectures] = useState([])

  const curLocationRef = useRef(location)
  const fields = [
    { field: 'id', placeholder: '', type: 'text', value: -1, visible: more && more === 'more', canSrch: false, selList: [] },
    { field: 'regTime', placeholder: '일시', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'topicName', placeholder: '토픽', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    // {field: 'topicCode', placeholder: '구분',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    { field: 'sendNm', placeholder: '발신인', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'title', placeholder: '제목', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'goal', placeholder: '대상', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'recvCnt', placeholder: '수신가능', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'readYes', placeholder: '읽음', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'attchCnt', placeholder: '첨부', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'content', placeholder: '내용', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
  ]
  const generalTopicCodeList = codes.filter((r) => r.codeGroupId === 'SA27' && !attdncCodes.includes(r.code))
  const termsRef = useRef({
    topicCodes: generalTopicCodeList.map((r) => r.code).toString(),
  })
  const [topicValue, set_topicValue] = useState('T')
  const [targetLectureId, set_targetLectureId] = useState(-1)
  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  const recordRef = useRef(defRecord)

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }

  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)

    if (newValue === '1') {
      const topicCodeList = generalTopicCodeList.map((r) => r.code)
      termsRef.current = { ...termsRef.current, topicCodes: topicCodeList.toString() }
      set_pageInfo({ ...pageInfo, pageNum: 0 })
    } else if (newValue == '2') {
      const topicCodeList = attdncCodes
      termsRef.current = { ...termsRef.current, topicCodes: topicCodeList.toString() }
      set_pageInfo({ ...pageInfo, pageNum: 0 })
    }
    const jsonMenu = localStorage.getItem('menu')
    if (jsonMenu) {
      const menu = JSON.parse(jsonMenu)
      menu.push.tabValue = newValue
      localStorage.setItem('menu', JSON.stringify(menu))
    }
  }

  const fetchMessage = async () => {
    if (tabValue == '-1') {
      return
    }
    const url = `/topic/${schola.id}`
    const newTerms = {}
    Object.keys(termsRef.current).forEach((key) => {
      if (termsRef.current[key]) {
        newTerms[key] = termsRef.current[key]
      }
    })

    const params = {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    }
    if(topicValue === 'TP06') {
      params.lectureId = termsRef.current.lectureId
    }
    console.log('params=>', params)
    openIndicator()
    const resp = await WebService.get(url, params)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    return JSON.parse(resp.repMessage)
  }

  const fetchSmsts = async () => {
    const url = `/smst/not/closed/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    records.sort((a, b) => b.id - a.id)
    records.forEach((r) => {
      r.isChecked = true
    })
    return records
  }

  const fetchLectures = async (smstIdList) => {
    const url = `/lecture/smstids`
    openIndicator()
    const resp = await WebService.post(url, smstIdList)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchAllLectures = async () => {
    const smstList = await fetchSmsts()
    let records = []

    if (smstList) {
      set_smstList(smstList)
      const idList = smstList.map(r => r.id)
      const lectures = await fetchLectures(idList)
      if(lectures) {
        lectures.sort((a,b) => a.title.localeCompare(b.title)) 
        for(const lecture of lectures) {
          const smst = smstList.find(r => r.id === lecture.smstId)
          lecture.gisu = smst?.gisu
          lecture.smstPhase = smst?.phase
        }
        lectures.sort((a,b) => a.smstPhase - b.smstPhase)
        set_lectures(lectures)
      }
    }
   
  }

  const onLoad = async () => {
    const data = await fetchMessage()
    if (!data) {
      return
    }

    const records = JSON.parse(data.records)
    const totalCount = data.totalCount

    set_totalCount(totalCount)
    records.forEach((r) => {
      r.topicName = findCode(codes, 'SA27', r.topicCode)?.name ?? ''
      r.attchCnt = r.attchList.length
    })
    set_dataList(records)
  }

  React.useEffect(() => {
    console.log(`pageInfo chagned topicValue:${topicValue}`)
    onLoad()
    if (topicValue === 'TP06') {
      fetchAllLectures()
    }
    else {
      set_targetLectureId(-1)
    }
  }, [pageInfo])

  React.useEffect(() => {
    const menu = JSON.parse(localStorage.getItem('menu')) || {}

    if (!menu.push) {
      menu.push = {}
    }

    if (menu.push.tabValue === undefined) {
      menu.push.tabValue = '1'
      localStorage.setItem('menu', JSON.stringify(menu))
    }

    handleTabChange(null, menu.push.tabValue)
    if (curLocationRef.current.key !== location.key) {
      set_pageInfo({ pageNum: 0, pageSize: 10 })
      curLocationRef.current = location
    }
  }, [location])

  const Body = () => {
    return (
      <div style={{ paddingTop: 0 }}>
        {tabValue === '1' ? (
          <>
            <Grid container spacing={2} style={{ marginBottom: 20 }}>
              <Grid item xs={6} sm={3}>
                <FormControl fullWidth>
                  <InputLabel id="topic" size="small" sx={{ fontSize: '0.9em' }}>
                    토픽
                  </InputLabel>
                  <Select
                    labelId="topic"
                    label="토픽"
                    size="small"
                    sx={{ fontSize: '0.9em' }}
                    value={topicValue}
                    onChange={(e) => {
                      if (e.target.value === 'T') {
                        const topicCodeList = generalTopicCodeList.map((r) => r.code)
                        termsRef.current = { ...termsRef.current, topicCodes: topicCodeList.toString() }
                      } else {
                        termsRef.current = { ...termsRef.current, topicCodes: e.target.value }
                      }
                      termsRef.current.lectureId = -1
                      set_targetLectureId(-1)
                      set_topicValue(e.target.value)
                      set_pageInfo({ ...pageInfo, pageNum: 0 })
                    }}
                  >
                    <MenuItem value={'T'}>전체</MenuItem>
                    {generalTopicCodeList.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s.code}>
                          {s.name}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {topicValue === 'TP06' ? (
                <Grid item xs={6} sm={3}>
                  <FormControl fullWidth>
                    <InputLabel id="lecture" size="small" sx={{ fontSize: '0.9em' }}>
                      강좌
                    </InputLabel>
                    <Select
                      labelId="lecture"
                      label="강좌"
                      size="small"
                      sx={{ fontSize: '0.9em' }}
                      value={targetLectureId}
                      onChange={(e) => {
                        if (e.target.value === -1) {
                          termsRef.current = { ...termsRef.current, lectureId: -1}
                        } else {
                          termsRef.current = { ...termsRef.current, lectureId: +e.target.value }
                        }
                        set_targetLectureId(+e.target.value)
                        set_pageInfo({ ...pageInfo, pageNum: 0 })
                      }}
                    >
                      <MenuItem value={-1}>전체</MenuItem>
                      {lectures.map((l, index) => {
                        return (
                          <MenuItem key={index} value={l.id}>
                            {l.gisu} 기 / {l.title}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              ) : null}
            </Grid>
          </>
        ) : null}
        <MUITable sx={{ minWidth: 1200 }}>
          <MyTableHead>
            <TableRow>
              {fields.map((col, index) =>
                col.visible ? (
                  <TableCell key={index} align="center" style={{ width: col.field == 'regTime' ? 200 : null }}>
                    {col.placeholder}
                  </TableCell>
                ) : null
              )}
            </TableRow>
          </MyTableHead>
          <TableBody>
            {dataList.map((row, index) => {
              return (
                <Fragment key={index}>
                  <TableRow
                    onMouseEnter={() => {
                      recordRef.current = row
                    }}
                  >
                    {fields.map((col, index2) => {
                      if (col.visible) {
                        return (
                          <TableCell
                            key={index2}
                            align="center"
                            style={{
                              cursor: col.field === 'content' || col.field === 'goal' ? 'pointer' : 'auto',
                            }}
                            onClick={() => {
                              if (col.field === 'content') {
                                dgHandler2[1](true)
                              } else if (col.field === 'goal') {
                                dgHandler3[1](true)
                              }
                            }}
                          >
                            <Typography variant="body2" fontWeight={col.field === 'goal' || col.field === 'content' ? 'bold' : 'normal'}>
                              {truncate(row[col.field], 30)}
                            </Typography>
                          </TableCell>
                        )
                      }
                    })}
                  </TableRow>
                </Fragment>
              )
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                sx={{
                  [`& .${tablePaginationClasses.spacer}`]: {
                    display: 'none',
                  },
                  [`& .${tablePaginationClasses.toolbar}`]: {
                    justifyContent: 'center',
                  },
                }}
                // rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
                rowsPerPageOptions={[10, 20, 50, 100]}
                colSpan={visibleColumns.length + 1}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={({ from, to, count }) => {
                  // return '' + from + '-' + to + ' 개 ' + count
                  return `${from} - ${to} of ${count}`
                }}
                labelRowsPerPage={'페이지당 갯수'}
              />
            </TableRow>
          </TableFooter>
        </MUITable>
      </div>
    )
  }
  return (
    <div>
      {dgHandler[0] ? <ManagerMessagePartPost dialogHandler={dgHandler} msgType="push" callback={onLoad} /> : null}
      {dgHandler2[0] ? (
        <MyDialog3
          title={recordRef.current.title}
          windowWidth="sm"
          dialogHandler={dgHandler2}
          component=<ManagerMessagePartView record={recordRef.current} dialogHandler={dgHandler2} />
        />
      ) : null}
      {dgHandler3[0] ? (
        <MyDialog3
          title={'수신정보'}
          windowWidth="sm"
          dialogHandler={dgHandler3}
          component=<ManagerMessagePartUser record={recordRef.current} dialogHandler={dgHandler3} />
        />
      ) : null}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: 10 }}>
          <h1>푸시 메시지 관리 </h1>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Button variant="contained" color="primary" size="small" startIcon={<SendOutlinedIcon />} sx={{ mr: 1 }} onClick={() => dgHandler[1](true)}>
          푸시 메시지 전송
        </Button>
      </div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="일반" value="1" />
              <Tab label="출결/이동/종료 알림" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="1" />
          </TabPanel>
          <TabPanel value="2" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="2" />
          </TabPanel>
        </TabContext>
      </Box>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </div>
  )
}
